// 保存登录后需要跳转的路径
export const SET_REDIRECT_URL = 'set_redirect_url'
// 保存用户登录信息
export const SET_USER = 'set_user'
// 清楚用户登录信息
export const CLEAR_USER = 'clear_user'